import React, { memo } from 'react';
import { useFeatureFlag } from '@olx/react-laquesis';
import useI18n from '../../../../i18n/hooks/useI18n';
import useFormattedPrice from '../../../../commons/hooks/useFormattedPrice';
import { SERVICE_FEE_PRICE } from '../../constants';
import S from './style/PaymentCard';
import { LabelPerLang, PriceValue, PriceComponent } from '../../../../../typings/transaction';
import InvoiceLink from './InvoiceLink';

interface PriceLineProps {
  code: string;
  value?: PriceValue;
  title?: string;
  label?: PriceComponent['label'];
  bold?: boolean;
  desktop?: boolean;
  tooltip?: JSX.Element | null;
  formattedValue?: string;
}

const PriceLine: React.FC<PriceLineProps> = memo(
  ({ value, title, label, code, bold, desktop, tooltip, formattedValue }) => {
    const i18n = useI18n();
    const formattedPrice = useFormattedPrice(value);
    const langIdx = i18n`dlv_generics_lang` as LabelPerLang;
    const isBTRRebrandingFlagOn = !!useFeatureFlag('DE-2170');
    const newBTRName = i18n('dlv_card_insurance_fee');

    return (
      <S.PriceBreakLine data-testid={code}>
        {(title || label) && (
          <>
            <S.PriceBreakLabelWrapper>
              <S.PriceBreakLabel data-cy="price-break-label">
                {tooltip}
                {title ||
                  (isBTRRebrandingFlagOn && code === SERVICE_FEE_PRICE
                    ? newBTRName
                    : label[langIdx])}
              </S.PriceBreakLabel>
              {code === SERVICE_FEE_PRICE && (
                <InvoiceLink desktop={desktop} isBTRRebrandingFlagOn={isBTRRebrandingFlagOn} />
              )}
            </S.PriceBreakLabelWrapper>
            <S.PriceBreakValue bold={bold}>{formattedValue || formattedPrice}</S.PriceBreakValue>
          </>
        )}
      </S.PriceBreakLine>
    );
  },
);

export default PriceLine;
